import { render, staticRenderFns } from "./SerchPage.vue?vue&type=template&id=700826e6&scoped=true&"
import script from "./SerchPage.vue?vue&type=script&lang=js&"
export * from "./SerchPage.vue?vue&type=script&lang=js&"
import style0 from "./SerchPage.vue?vue&type=style&index=0&id=700826e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700826e6",
  null
  
)

export default component.exports